module.exports = __webpack_public_path__ + "static/media/strange2.a20ce4d5.png";